import { useNavigate, useLocation } from "react-router";
import { injectIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, Stack, Tooltip, Typography } from "@mui/material";
import { azzeraMonitoraggio, CODICE_EVENTO, getMonitoraggio, SUBSCRIBE_EVENT, UNSUBSCRIBE_EVENT } from "../../modules/tracking";
import {
  HOME_LABEL,
  INFO_LABEL,
  NOTIFICATION_ACTIVE,
  NOTIFICATION_ACTIVE_ARIA_LABEL,
  NOTIFICATION_UNACTIVE,
  NOTIFICATION_UNACTIVE_ARIA_LABEL,
} from "../../modules/language";
import { PATH_HOME, PATH_INFO } from "../../path";
import { getMessageString } from "../../utility";
import { PSTrackerBiancoIcon } from "../../styles/images";
import { CambioLingua } from "./CambioLingua";
import { Icona } from "./";

export const Header = injectIntl(({ intl }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();
  const monitoraggio = useSelector(getMonitoraggio);
  const fromSaluteSimplex = window.ReactNativeWebView != null;

  const path = location.pathname;

  return (
    <>
      <Typography variant="h1" sx={{ position: "absolute", left: "-9999px" }}>
        PS Tracker
      </Typography>
      <Box className="header">
        {path !== PATH_HOME && (
          <Button
            onClick={() => {
              navigate(PATH_HOME);
              dispatch(azzeraMonitoraggio());
            }}
            className="homeLink"
          >
            <Icona tipologia="home" />
            <Typography>{getMessageString(intl, HOME_LABEL)}</Typography>
          </Button>
        )}
        <Stack sx={{ opacity: fromSaluteSimplex ? 0 : 1 }} className="appName">
          <PSTrackerBiancoIcon />
        </Stack>
        {monitoraggio && (
          <Stack className="notifications">
            <Tooltip title={getMessageString(intl, NOTIFICATION_ACTIVE_ARIA_LABEL)} placement="bottom" arrow>
              <Button
                id="subButton"
                sx={{ display: "none" }}
                aria-label={getMessageString(intl, NOTIFICATION_ACTIVE_ARIA_LABEL)}
                onClick={() => {
                  if (fromSaluteSimplex) window.ReactNativeWebView?.postMessage(JSON.stringify({ unsubscribe: monitoraggio[CODICE_EVENTO] }));
                  else window.dispatchEvent(new CustomEvent(UNSUBSCRIBE_EVENT));
                }}
              >
                <Icona tipologia="notifica" />
                <Typography>{getMessageString(intl, NOTIFICATION_ACTIVE)}</Typography>
              </Button>
            </Tooltip>
            <Tooltip title={getMessageString(intl, NOTIFICATION_UNACTIVE_ARIA_LABEL)} placement="bottom" arrow>
              <Button
                id="unsubButton"
                sx={{ display: "none" }}
                aria-label={getMessageString(intl, NOTIFICATION_UNACTIVE_ARIA_LABEL)}
                onClick={() => {
                  if (fromSaluteSimplex) window.ReactNativeWebView?.postMessage(JSON.stringify({ subscribe: monitoraggio[CODICE_EVENTO] }));
                  else window.dispatchEvent(new CustomEvent(SUBSCRIBE_EVENT));
                }}
              >
                <Icona tipologia="notifica_disattivata" />
                <Typography>{getMessageString(intl, NOTIFICATION_UNACTIVE)}</Typography>
              </Button>
            </Tooltip>
          </Stack>
        )}
        <Stack direction="row">
          <Button onClick={() => navigate(PATH_INFO)} className="infoPath">
            <Icona tipologia="faq" />
            <Typography>{getMessageString(intl, INFO_LABEL)}</Typography>
          </Button>
          <CambioLingua />
        </Stack>
      </Box>
    </>
  );
});
